import { render, staticRenderFns } from "./Snake.vue?vue&type=template&id=31f779b0&scoped=true&"
import script from "./Snake.vue?vue&type=script&lang=ts&"
export * from "./Snake.vue?vue&type=script&lang=ts&"
import style0 from "./Snake.vue?vue&type=style&index=0&id=31f779b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f779b0",
  null
  
)

export default component.exports